.ux-iws-media-bar {
    display: block;
    position: relative;

    &__wrapper {
        display: flex;
        flex-direction: column;

        @media (min-width: 1440px) {
            flex-direction: row;
        }
    }

    &__media-container {
        width: 100%;
        position: relative;
        margin: 0 auto;
    }

    &__content-container {
        margin: 0 auto;

        @media (min-width: 1440px) {
            width: 100%;
        }
    }

    *[slot="media"] {
        padding: 0 30px 0 0;
        margin: 0 15px;

        @media (min-width: 568px) {
            margin: 0;
            padding: 0 30px 0 0;
        }

        @media (min-width: 1440px) {
            padding: 0;
        }
    }

    *[slot="media"] img {
        display: block;
    }

    *[slot="content"] {
        margin-top: -15px;
        margin-left: 45px;
        padding: 30px 30px 10px;
        margin-right: 15px;
        box-shadow: 0 0 22px transparentize($color-black, 0.92);
        background-color: $color-white;
        position: relative;

        @media (min-width: 568px) {
            margin-top: -30px;
            margin-left: 30px;
        }

        @media (min-width: 1024px) {
            padding: 50px 60px 30px;
        }

        @media (min-width: 1440px) {
            margin-left: -80px;
            margin-top: 30px;
            margin-right: 0;
        }
    }

    .btn,
    .ux-button {
        display: block;
        width: 100%;
        margin-bottom: 20px;

        @media (min-width: 568px) {
            width: auto;
            display: inline-block;
            margin-right: 20px;
        }
    }
}
